<template>
  <div
    :class="{pdf: $route.name == 'product-to-pdf' || $route.name == 'admin-product-to-pdf' || $route.name == 'products-to-pdf'}"
    id="app"
  >
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: "App",
  metaInfo: {
    title: "Southgate Lighting",
    titleTemplate: "%s"
  }
}
</script>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css";
@import "https://fonts.googleapis.com/css?family=Roboto:300,400,500,600";
@import "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap";
@import "https://unpkg.com/aos@next/dist/aos.css";
@import "./assets/css/plugins.css";
@import "./assets/css/base.css";

</style>
